import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { Flex, KeyboardBadge, token } from '@bynder/design-system';

const clientOS = navigator.userAgent.toLowerCase();
const isCommandKey = clientOS.includes('mac');

// TODO: Temporary, will be fixed in DS or changed later
const StyledWrapper = styled(Flex)`
    kbd {
        box-shadow: none;
        color: ${token.gray600};
    }
`;

const shortcutsSymbols = {
    cmd: '⌘',
    ctrl: '⌃',
    opt: '⌥',
    alt: 'alt',
    shift: '⇧',
    backspace: '⌫',
    space: '␣',
};

export const parseShortcutForTooltip = (shortcut: string[]) => {
    return shortcut.reduce((accum, cur) => {
        let btn = cur.toLowerCase();

        const symbolMap: Record<string, string> = {
            cmd: isCommandKey ? shortcutsSymbols.cmd : shortcutsSymbols.ctrl,
            ctrl: isCommandKey ? shortcutsSymbols.cmd : shortcutsSymbols.ctrl,
            opt: shortcutsSymbols.opt,
            alt: shortcutsSymbols.opt,
            shift: shortcutsSymbols.shift,
            backspace: shortcutsSymbols.backspace,
            space: shortcutsSymbols.space,
        };

        btn = symbolMap[btn] || btn;

        return accum + (btn.length > 1 ? btn : btn.toUpperCase());
    }, '');
};

export const WithShortcutLabel = ({ children, shortcut }: { children: ReactNode; shortcut: string[] }): ReactNode => {
    return (
        <Flex justifyContent="space-between" alignItems="center" gap="6">
            <div>{children}</div>
            <StyledWrapper gap="3" justifyContent="flex-end">
                <KeyboardBadge>{parseShortcutForTooltip(shortcut)}</KeyboardBadge>
            </StyledWrapper>
        </Flex>
    );
};
